import { render, staticRenderFns } from "./ShopEditBranch.vue?vue&type=template&id=b2f467b6&scoped=true&"
import script from "./ShopEditBranch.vue?vue&type=script&lang=ts&"
export * from "./ShopEditBranch.vue?vue&type=script&lang=ts&"
import style0 from "./ShopEditBranch.vue?vue&type=style&index=0&id=b2f467b6&lang=scss&scoped=true&"
import style1 from "./ShopEditBranch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f467b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
